import React, { useContext } from 'react';
import FalconContext from '../contexts/falcon.context';

const postCountDownStates = [
  'liftoff',
  'preMaxQ',
  'maxQ',
  'superSonic',
  'postSuperSonic',
  'preMeco',
];

const FirstStageFlare = props => {
  const { className } = props;
  const falconState = useContext(FalconContext);
  const firstStageFlareImagePath = 'assets/rocket-flare.gif';
  let showFlare = postCountDownStates.includes(falconState.state);
  return showFlare ? <img className={`${className}`} src={firstStageFlareImagePath} /> : null;
};

export default FirstStageFlare;
